import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button/Button";
import Typography from "@material-ui/core/Typography/Typography";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import OptionsTable from "./OptionsTable";
import * as ReactGA from "react-ga";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import useDetectPrint from 'use-detect-print';

const useStyles = makeStyles({
    root: {
        marginTop: 30,
    },
    btn: {
        marginLeft: 0,
        marginTop: 10,
    },
    btnClose: {
        marginLeft: 20,
        marginTop: 20,
        marginBottom: 20,
        maxWidth: 40,
        minHeight: 30,
    },
    closeButton: {
        position: 'fixed',
        right: 20,
        background: '#fff',
        border: '1px solid #ccc',
        top: 10,
        zIndex: 1000,
    },
    contactIcon: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 0,
        borderBottom: '1px dashed #ccc',
        paddingBottom: 5
    },

});

export default function Options(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState();

    const item = props.item;
    const allItems = item.options;
    const isPreview = props.isPreview;

    const isMobile = props.isMobile;

    let maxItems = isPreview ? (isMobile ? 10 : 10) : allItems.length;

    const isPrinting = useDetectPrint();

    if (isPrinting) {
        maxItems = allItems.length;
    }

    const hasExpand = allItems.length > maxItems;

    const handleOpen = () => {
        if (!open) {
            setOpen(true);
            ReactGA.event({
                category: 'User',
                action: 'options_view'
            });
        }
    };

    const handleClose = () => {
        if (open) {
            setOpen(false)
        }
    };

    return (
        <div className={classes.root}>
            <Dialog fullScreen={true} scroll="paper" open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="customized-dialog-title">
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    Options
                </DialogTitle>
                <DialogContent>
                    <OptionsTable items={allItems} isMobile={isMobile} isPreview={false}/>
                </DialogContent>
                <Button variant="outlined" size="small" onClick={handleClose} className={classes.btnClose}>Close</Button>
            </Dialog>
            <div className={classes.contactIcon}>
                <Typography>Options</Typography>
                <ArrowDropDownIcon style={{
                    paddingLeft: '5',
                }}/>
            </div>
            <OptionsTable items={allItems} isMobile={isMobile} isPreview={true}/>
            {hasExpand ? <Button variant="outlined" size="small" onClick={handleOpen} className={classes.btn}>All Options</Button> : ''}
        </div>
    );
}